export default "__VITE_ASSET__652365e5__"